import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "position-absolute badge"
}
const _hoisted_2 = { class: "pt-2" }

import Icon from "@/components/Icons/Icon.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'RoundButton',
  props: {
  icon: {
    type: String,
  },
  label: {
    type: String,
  },
  color: {
    type: String,
    default: 'white',
  },
  customClass: {
    type: String,
    default: 'primary-button-gradient',
  },
  badgeContent: {
    type: [Number],
  },
},
  emits: ['click'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createBlock(_component_v_col, { class: "d-flex flex-column align-center" }, {
    default: _withCtx(() => [
      _createElementVNode("button", {
        class: _normalizeClass(`position-relative round-primary-button ${__props.customClass}`),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
      }, [
        _createVNode(Icon, {
          color: __props.color,
          icon: __props.icon
        }, null, 8, ["color", "icon"]),
        (__props.badgeContent)
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(__props.badgeContent), 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("p", _hoisted_2, _toDisplayString(__props.label), 1)
    ]),
    _: 1
  }))
}
}

})